import React, { useState, useEffect } from 'react';

const CookieBanner: React.FC = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(true);
  const [toggle1, setToggle1] = useState(false);
  const [toggle2, setToggle2] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (consent === "all" || consent) {
      setBannerVisible(false);
    }
  }, []);

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  };

  const handleAcceptAll = () => {
    console.log("คุณยอมรับคุกกี้ทั้งหมดแล้ว");
    setBannerVisible(false);
    localStorage.setItem("cookie-consent", "all");
  };

  const handleSaveSettings = () => {
    console.log("การตั้งค่าคุกกี้ของคุณถูกบันทึกแล้ว");
    setModalVisible(false);
    setBannerVisible(false);
    localStorage.setItem("cookie-consent", "custom");
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  if (!bannerVisible) {
    return null;
  }

  return (
    <>
      {/* Cookie Banner */}
      <div className="cookie-banner" id="cookie-banner">
        <div className="cookie-banner-content">
          <div className="cookie-notice">
            <p>
              เว็บไซต์นี้ใช้คุกกี้เพื่อปรับปรุงประสบการณ์การใช้งานของคุณกรุณาอ่าน
              <a
                href="#"
                className="cookie-link"
                data-bs-target="#MD_E987"
                data-bs-toggle="modal"
              >
                ข้อตกลงในการใช้บริการ
              </a>
              และ
              <a
                href="#"
                data-bs-toggle="modal"
                className="cookie-link"
                data-bs-target="#MD_5D31"
              >
                นโยบายการใช้คุกกี้
              </a>
              เพื่อดูข้อมูลเพิ่มเติม
            </p>
          </div>
          <div className="cookie-buttons">
            <button
              className="btn-settings"
              onClick={toggleModal}
            >
              ตั้งค่าคุกกี้
            </button>
            <button 
              className="btn-accept"
              onClick={handleAcceptAll}
            >
              ยอมรับคุกกี้ทั้งหมด
            </button>
          </div>
        </div>
      </div>

      {/* Cookie Settings Modal */}
      {modalVisible && (
        <div className={`cookie-settings-modal ${modalVisible ? 'show' : ''}`}>
          <div className="cookie-settings">
            <h3>การตั้งค่าคุกกี้</h3>
            <div className="div-cookie">
              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div>
                      <label className="text-cookie">ตั้งค่าคุกกี้</label>
                    </div>
                    <div>
                      <label className="text-cookie1">
                        คุกกี้เหล่านี้จำเป็นสำหรับการทำงานของเว็บไซต์และไม่สามารถปิดใช้งานได้
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-4 col-lg-4 col-12 margin-20">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <label className="text-cookie">คุกกี้วิเคราะห์</label>
                      <div className="toggle-container">
                        <div
                          className={`toggle ${toggle1 ? 'active' : ''}`}
                          onClick={() => setToggle1(!toggle1)}
                        ></div>
                      </div>
                    </div>
                    <div>
                      <label className="text-cookie1">
                        ช่วยให้เราทราบพฤติกรรมการใช้งาน เพื่อปรับปรุงเว็บไซต์
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 col-12 margin-20">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <label className="text-cookie">คุกกี้สำหรับการตลาด</label>
                      <div className="toggle-container">
                        <div
                          className={`toggle ${toggle2 ? 'active' : ''}`}
                          onClick={() => setToggle2(!toggle2)}
                        ></div>
                      </div>
                    </div>
                    <div>
                      <label className="text-cookie1">
                        ช่วยให้เรานำเสนอเนื้อหาและโฆษณาที่ตรงกับความสนใจของคุณ
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="settings-buttons">
              <button className="btn-cancel" onClick={handleCancel}>
                ยกเลิก
              </button>
              <button className="btn-save" onClick={handleSaveSettings}>
                บันทึก
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
